<template>
    <div>
        <div>
            <div class="plan_section_" v-if="planValue=='2'">
                <div class="header_">
                    <span>大中华</span>
                    <span @click="planDesc[4].unexpand = !planDesc[4].unexpand" 
                        class="h_right_">
                        {{planDesc[4].unexpand ? '展开' : '收起'}}
                        <a-icon :type="planDesc[4].unexpand ? 'down' : 'up'">
                        </a-icon>
                    </span>
                </div>
                <div v-if="!planDesc[4].unexpand" class="content_">
                    <table class="table_">
                        <col width="50%">
                        <col width="50%">
                        <tr><td>计划类型</td><td>大中华/大中华加强计划</td></tr>
                        <tr><td>每年最高保额</td><td>2,400,000</td></tr>
                        <tr><td>医院涵盖范围</td><td>公立+私立+昂贵</td></tr>
                        <tr><td>昂贵医院赔付比例</td><td>赔付60%</td></tr>
                        <tr><td colspan="2" style="text-align:center">住院医疗保险责任</td></tr>
                        <tr><td>床位费</td><td>双人病房（在中国大陆接受住院治疗的，可为标准单人病房；如果医院没有双人病房，则按标准单人病房赔付）</td></tr>
                        <tr><td>膳食和营养配餐费（仅限于病人）</td><td>100%赔付</td></tr>
                        <tr><td>加床费（未满18周岁子女父母一人陪同住院，未满16周新生婴儿随母住院）</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>手术辅料费</td><td>100%赔付</td></tr>
                        <tr><td>输血费</td><td>100%赔付</td></tr>
                        <tr><td>药品费</td><td>100%赔付</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>护理费</td><td>100%赔付</td></tr>
                        <tr><td>吸氧费</td><td>100%赔付</td></tr>
                        <tr><td>化验费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>接受器官，骨髓，干细胞移植费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>康复治疗和专业护理费用</td><td>累计以90日为上限</td></tr>
                        <tr><td colspan="2" style="text-align:center">门诊医疗保险责任</td></tr>
                        <tr><td>门诊处方药（医生处方开具的药品，含OTC，中草药）</td><td>年限额16,000，上限90日</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>急诊室费</td><td>100%赔付</td></tr>
                        <tr><td>非紧急情况下使用急诊室</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>针灸治疗，顺势疗法费</td><td>年限额4,000</td></tr>
                        <tr><td>理疗费</td><td>年限额40,000</td></tr>
                        <tr><td>紧急牙科</td><td>年限额40,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">特定筛查和其他特殊医疗福利（受限于住院和门诊上限）</td></tr>
                        <tr><td>45岁以上女性筛查</td><td>100%赔付</td></tr>
                        <tr><td>45岁以上男性筛查</td><td>100%赔付</td></tr>
                        <tr><td>家族病史筛查</td><td>年限额2,000</td></tr>
                        <tr><td>专业护士家庭护理费</td><td>累计以100日为上限</td></tr>
                        <tr><td>耐用医疗设备购买或租赁费</td><td>100%赔付</td></tr>
                        <tr><td>临终关怀费</td><td>住院以45日为上限，门诊上限40,000</td></tr>
                        <tr><td>艾滋病</td><td>理赔在重大疾病下</td></tr>
                        <tr><td>精神和心理障碍治疗费</td><td>住院治疗每个保险年度上限50,000，门诊治疗上限20次/不包含</td></tr>
                        <tr><td>酒精和药物滥用</td><td>年限额20,000</td></tr>
                        <tr><td>睡眠检查和治疗费</td><td>100%赔付</td></tr>
                        <tr><td>先天性疾病和症状治疗费</td><td>年限额60,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">生育</td></tr>
                        <tr><td>分娩费：产前检查费，妊娠期内医师处方开具的维生素和钙剂费，超声波检查费，顺产费，医学必须剖腹产费，麻醉费，产后复查费，流产费，产后医学必需盆底修复治疗费等</td><td>首次入保未满12个月：没有等待期；每次怀孕分娩费与新生婴儿护理费合并累计最多理赔8,000，连续投保满12个月后：每次怀孕最高理赔 68,000，超过部分不理赔。选择性流产费每人每年限一次。	</td></tr>
                        <tr><td>妊娠并发症治疗费</td><td>受限于门诊和住院上限</td></tr>
                        <tr><td>新生婴儿费用-仅限于出生后14天内的治疗费用（新生儿未投保亦可使用）</td><td>母亲首次入保未满12个月：与生育责任合并累计最多理赔 8,000；<br>母亲连续投保满12个月后：限于门诊医疗或住院医疗上限</td></tr>
                        <tr><td>新生婴儿福利-仅限于1周岁以内婴儿使用（母亲连续投保超过12个月且新生儿在出生后30天内投保，方可享用此福利）</td><td>1）新生儿疫苗费全额赔付（含进口疫苗）<br>2）最多6次的新生儿体检费全额赔付</td></tr>
                    </table>
                </div>
            </div>
            <div class="plan_section_" v-if="planValue=='3'">
                <div class="header_">
                    <span>全球除美</span>
                    <span @click="planDesc[5].unexpand = !planDesc[5].unexpand" 
                        class="h_right_">
                        {{planDesc[5].unexpand ? '展开' : '收起'}}
                        <a-icon :type="planDesc[5].unexpand ? 'down' : 'up'">
                        </a-icon>
                    </span>
                </div>
                <div v-if="!planDesc[5].unexpand" class="content_">
                    <table class="table_">
                        <col width="50%">
                        <col width="50%">
                        <tr><td>计划类型</td><td>全球除美/全球除美增强计划</td></tr>
                        <tr><td>每年最高保额</td><td>16,000,000</td></tr>
                        <tr><td>医院涵盖范围</td><td>公立+私立+昂贵</td></tr>
                        <tr><td>昂贵医院赔付比例</td><td>赔付80%</td></tr>
                        <tr><td colspan="2" style="text-align:center">住院医疗保险责任</td></tr>
                        <tr><td>床位费</td><td>双人病房（在中国大陆接受住院治疗的，可为标准单人病房；如果医院没有双人病房，则按标准单人病房赔付）</td></tr>
                        <tr><td>膳食和营养配餐费（仅限于病人）</td><td>100%赔付</td></tr>
                        <tr><td>加床费（未满18周岁子女父母一人陪同住院，未满16周新生婴儿随母住院）</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>手术辅料费</td><td>100%赔付</td></tr>
                        <tr><td>输血费</td><td>100%赔付</td></tr>
                        <tr><td>药品费</td><td>100%赔付</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>护理费</td><td>100%赔付</td></tr>
                        <tr><td>吸氧费</td><td>100%赔付</td></tr>
                        <tr><td>化验费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>接受器官，骨髓，干细胞移植费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>康复治疗和专业护理费用</td><td>累计以90日为上限</td></tr>
                        <tr><td colspan="2" style="text-align:center">门诊医疗保险责任</td></tr>
                        <tr><td>门诊处方药（医生处方开具的药品，含OTC，中草药）</td><td>上限90日	</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>急诊室费</td><td>100%赔付</td></tr>
                        <tr><td>非紧急情况下使用急诊室</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>针灸治疗，顺势疗法费</td><td>年限额4,000</td></tr>
                        <tr><td>理疗费</td><td>年限额40,000</td></tr>
                        <tr><td>紧急牙科</td><td>年限额40,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">特定筛查和其他特殊医疗福利（受限于住院和门诊上限）</td></tr>
                        <tr><td>45岁以上女性筛查</td><td>100%赔付</td></tr>
                        <tr><td>45岁以上男性筛查</td><td>100%赔付</td></tr>
                        <tr><td>家族病史筛查</td><td>年限额2,000</td></tr>
                        <tr><td>专业护士家庭护理费</td><td>累计以100日为上限</td></tr>
                        <tr><td>耐用医疗设备购买或租赁费</td><td>100%赔付</td></tr>
                        <tr><td>临终关怀费</td><td>住院以45日为上限，门诊上限40,000</td></tr>
                        <tr><td>艾滋病</td><td>理赔在重大疾病下</td></tr>
                        <tr><td>精神和心理障碍治疗费</td><td>住院治疗每个保险年度上限50,000，门诊治疗上限20次/不包含</td></tr>
                        <tr><td>酒精和药物滥用</td><td>年限额20,000</td></tr>
                        <tr><td>睡眠检查和治疗费</td><td>100%赔付</td></tr>
                        <tr><td>先天性疾病和症状治疗费</td><td>年限额60,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">生育</td></tr>
                        <tr><td>分娩费：产前检查费，妊娠期内医师处方开具的维生素和钙剂费，超声波检查费，顺产费，医学必须剖腹产费，麻醉费，产后复查费，流产费，产后医学必需盆底修复治疗费等</td><td>首次入保未满12个月：没有等待期；每次怀孕分娩费与新生婴儿护理费合并累计最多理赔 8,000，连续投保满12个月后：每次怀孕最高理赔 68,000，超过部分不理赔。选择性流产费每人每年限一次。</td></tr>
                        <tr><td>妊娠并发症治疗费</td><td>受限于门诊和住院上限</td></tr>
                        <tr><td>新生婴儿费用-仅限于出生后14天内的治疗费用（新生儿未投保亦可使用）</td><td>母亲首次入保未满12个月：与生育责任合并累计最多理赔 8,000；<br>母亲连续投保满12个月后：限于门诊医疗或住院医疗上限</td></tr>
                        <tr><td>新生婴儿福利-仅限于1周岁以内婴儿使用（母亲连续投保超过12个月且新生儿在出生后30天内投保，方可享用此福利）</td><td>1）新生儿疫苗费全额赔付（含进口疫苗）<br>2）最多6次的新生儿体检费全额赔付</td></tr>
                    </table>
                </div>
            </div>
            <div class="plan_section_" v-if="planValue=='4'">
                <div class="header_">
                    <span>全球</span>
                    <span @click="planDesc[6].unexpand = !planDesc[6].unexpand" 
                        class="h_right_">
                        {{planDesc[6].unexpand ? '展开' : '收起'}}
                        <a-icon :type="planDesc[6].unexpand ? 'down' : 'up'">
                        </a-icon>
                    </span>
                </div>
                <div v-if="!planDesc[6].unexpand" class="content_">
                    <table class="table_">
                        <col width="50%">
                        <col width="50%">
                        <tr><td>计划类型</td><td>全球计划</td></tr>
                        <tr><td>每年最高保额</td><td>16,000,000</td></tr>
                        <tr><td>医院涵盖范围</td><td>公立+私立+昂贵</td></tr>
                        <tr><td>昂贵医院赔付比例</td><td>赔付100%</td></tr>
                        <tr><td colspan="2" style="text-align:center">住院医疗保险责任</td></tr>
                        <tr><td>床位费</td><td>双人病房（在中国大陆接受住院治疗的，可为标准单人病房；如果医院没有双人病房，则按标准单人病房赔付）</td></tr>
                        <tr><td>膳食和营养配餐费（仅限于病人）</td><td>100%赔付</td></tr>
                        <tr><td>加床费（未满18周岁子女父母一人陪同住院，未满16周新生婴儿随母住院）</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>手术辅料费</td><td>100%赔付</td></tr>
                        <tr><td>输血费</td><td>100%赔付</td></tr>
                        <tr><td>药品费</td><td>100%赔付</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>护理费</td><td>100%赔付</td></tr>
                        <tr><td>吸氧费</td><td>100%赔付</td></tr>
                        <tr><td>化验费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>接受器官，骨髓，干细胞移植费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>康复治疗和专业护理费用</td><td>累计以90日为上限</td></tr>
                        <tr><td colspan="2" style="text-align:center">门诊医疗保险责任</td></tr>
                        <tr><td>门诊处方药（医生处方开具的药品，含OTC，中草药）</td><td>上限90日；在美国网络以外: 20%自付额<br>在美国，用量以180日为上限。</td></tr>
                        <tr><td>医师诊疗费</td><td>100%赔付</td></tr>
                        <tr><td>检查费</td><td>100%赔付</td></tr>
                        <tr><td>手术室和恢复室费</td><td>100%赔付</td></tr>
                        <tr><td>急诊室费</td><td>100%赔付</td></tr>
                        <tr><td>非紧急情况下使用急诊室</td><td>100%赔付</td></tr>
                        <tr><td>手术医师费和麻醉师费</td><td>100%赔付</td></tr>
                        <tr><td>放射治疗，化学治疗费</td><td>100%赔付</td></tr>
                        <tr><td>针灸治疗，顺势疗法费</td><td>年限额4,000</td></tr>
                        <tr><td>理疗费</td><td>年限额40,000</td></tr>
                        <tr><td>紧急牙科</td><td>年限额40,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">特定筛查和其他特殊医疗福利（受限于住院和门诊上限）</td></tr>
                        <tr><td>45岁以上女性筛查</td><td>100%赔付</td></tr>
                        <tr><td>45岁以上男性筛查</td><td>100%赔付</td></tr>
                        <tr><td>家族病史筛查</td><td>年限额2,000</td></tr>
                        <tr><td>专业护士家庭护理费</td><td>累计以100日为上限</td></tr>
                        <tr><td>耐用医疗设备购买或租赁费</td><td>100%赔付</td></tr>
                        <tr><td>临终关怀费</td><td>住院以45日为上限，门诊上限40,000</td></tr>
                        <tr><td>艾滋病</td><td>理赔在重大疾病下</td></tr>
                        <tr><td>精神和心理障碍治疗费</td><td>住院治疗每个保险年度上限50,000，门诊治疗上限20次/不包含</td></tr>
                        <tr><td>酒精和药物滥用</td><td>年限额20,000</td></tr>
                        <tr><td>睡眠检查和治疗费</td><td>100%赔付</td></tr>
                        <tr><td>先天性疾病和症状治疗费</td><td>年限额60,000</td></tr>
                        <tr><td colspan="2" style="text-align:center">生育</td></tr>
                        <tr><td>分娩费：产前检查费，妊娠期内医师处方开具的维生素和钙剂费，超声波检查费，顺产费，医学必须剖腹产费，麻醉费，产后复查费，流产费，产后医学必需盆底修复治疗费等</td><td>首次入保未满12个月：没有等待期；每次怀孕分娩费与新生婴儿护理费合并累计最多理赔 8,000，连续投保满12个月后：每次怀孕最高理赔 68,000，超过部分不理赔。选择性流产费每人每年限一次。</td></tr>
                        <tr><td>妊娠并发症治疗费</td><td>受限于门诊和住院上限</td></tr>
                        <tr><td>新生婴儿费用-仅限于出生后14天内的治疗费用（新生儿未投保亦可使用）</td><td>母亲首次入保未满12个月：与生育责任合并累计最多理赔 8,000；<br>母亲连续投保满12个月后：限于门诊医疗或住院医疗上限</td></tr>
                        <tr><td>新生婴儿福利-仅限于1周岁以内婴儿使用（母亲连续投保超过12个月且新生儿在出生后30天内投保，方可享用此福利）</td><td>1）新生儿疫苗费全额赔付（含进口疫苗）<br>2）最多6次的新生儿体检费全额赔付</td></tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选责任:全球紧急救援</span>
                <span @click="planDesc[0].unexpand = !planDesc[0].unexpand" 
                    class="h_right_">
                    {{planDesc[0].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[0].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[0].unexpand" class="content_">
                <table class="table_">
                    <col width="33%" />
                    <col width="33%" />
                    <col width="33%" />
                    <tr><td>紧急医疗运送费用</td><td colspan="2">100%赔付</td></tr>
                    <tr><td>紧急医疗转运费（包括一名陪同人员住宿和公共交通费）</td><td colspan="2">陪同人员住宿费限12日，每日限RMB800元。</td></tr>
                    <tr><td>遗体运返或安葬</td><td colspan="2">以人民币160,000元为上限</td></tr>
                </table>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选责任：体检福利</span>
                <span @click="planDesc[1].unexpand = !planDesc[1].unexpand" 
                    class="h_right_">
                    {{planDesc[1].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[1].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[1].unexpand" class="content_">
                <table class="table_">
                    <col width="33%">
                    <col width="33%">
                    <col width="33%">
                    <tr><td>体检福利年度总限额</td><td colspan="2">3,200</td></tr>
                </table>
            </div>
        </div>
        <div  class="plan_section_">
            <div class="header_">
                <span>可选责任：牙科福利 </span>
                <span @click="planDesc[2].unexpand = !planDesc[2].unexpand" 
                    class="h_right_">
                    {{planDesc[2].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[2].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[2].unexpand" class="content_">
                <table class="table_">
                    <col width="33%">
                    <col width="33%">
                    <col width="33%">
                    <tr><td>牙科福利年度总限额</td><td colspan="2">4,000/9,600</td></tr>
                    <tr><td>预防治疗</td><td>100%赔付</td><td>100%赔付</td></tr>
                    <tr><td>基本牙科治疗</td><td>80%赔付</td><td>80%赔付</td></tr>
                    <tr><td>重大牙科治疗</td><td>50%赔付</td><td>50%赔付</td></tr>
                </table>
            </div>
        </div>
        <div class="plan_section_">
            <div class="header_">
                <span>可选责任：眼科福利</span>
                <span @click="planDesc[3].unexpand = !planDesc[3].unexpand" 
                    class="h_right_">
                    {{planDesc[3].unexpand ? '展开' : '收起'}}
                    <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'">
                    </a-icon>
                </span>
            </div>
            <div v-if="!planDesc[3].unexpand" class="content_">
                <table class="table_">
                    <col width="33%">
                    <col width="33%">
                    <col width="33%">
                    <tr><td>眼科福利年度总限额</td><td colspan="2">2,400</td></tr>
                    
                </table>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .table_ {
        border-color: #eee;
        border: 1px solid #eee;
        width: 100%;
        table-layout: fixed;
        .center_ {
            text-align: center;
        }
        td {
            border: 1px solid #eee;
            text-align: center;
            &:nth-child(1) {
                color: #333;
                font-weight: bold;
                padding-left: 12px;
                text-align: left;
                word-break: break-word;
            }
        }
    }
    .plan_section_ {
        margin: 12px 0;
        color: #6e6e6e;
        border-radius: 16px;
        box-shadow: 0rem 0rem 6px 0rem rgba(96, 130, 253, 0.47);
        overflow: hidden;

        .header_ {
            line-height: 30px;
            display: flex;
            justify-content: space-between;
            background: linear-gradient(to bottom, #92a9fc 0%, #6284fe 100%);
            font-size: 14px;
            padding: 5px 12px;
            color: #fff;
            .h_right_ {
                font-size: 12px;
            }
        }
        .pre_ {
            white-space: pre-wrap;
        }
        .content_ {
            margin: 12px;
            font-size: 12px;
        }
        .flex_row_ {
            display: flex;
            align-items: center;
        }
        .place_ {
            visibility: hidden;
        }
        .lh37_ {
            line-height: 36px;
        }
        .left_ {
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
            padding-left: 6px;
            color: #333;
            font-weight: bold;
        }
        .right_ {
            text-align: center;
            border-right: 1px solid #eee;
            border-bottom: 1px solid #eee;
        }
        .line_h_ {
            line-height: 50px;
        }
    }
</style>
<script>
export default {
    props: {
        edit: {
            type: Boolean,
            default: true
        },
        planValue: {
            type: String,
            default: '2'
        }
    },
    data () {
        return {
            planDesc: [
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true },
                { unexpand: true }
            ]
        }
    }
}
</script>